import axiosService  from './request';
import qs from 'qs'; 

const categoryList = '/api/cms/category/list' // 导航栏列表
const contentList = '/api/cms/content/list' // 导航栏列表
const tagsList = '/api/mdiy/dict/list' // 文章标签

export const getCategoryList = (data) => {
    return axiosService .post(categoryList, data)
}

export const getContentList = (data) => {
    const encodedData = qs.stringify(data); 
    return axiosService.post(contentList, encodedData);
}


export const getTagsList = (data) => {
    return axiosService.get(tagsList, data);
}